import { VCol } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VFooter,{attrs:{"color":"white"}},[_c(VCol,{staticClass:"caption text-center",attrs:{"cols":"12"}},[_vm._v(" © "+_vm._s(_vm.year)+" Impactiv - Tous droits réservés ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }